import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { PackageCheck } from "lucide-react";
import { TrocoSaidaCheck } from "./MobileTrocoSaida";

// Dialog "está com o pedido em mãos?" (individual ou Confirmar Todas) com check obrigatório do troco de saída.
export function ConfirmarRecebimentoDialog({ confirmReceipt, saving, onClose, onToggleTroco, onConfirm }) {
  const trocoList = confirmReceipt?.trocoList || [];
  const precisaTroco = trocoList.length > 0 && !confirmReceipt?.trocoOk;
  return (
    <Dialog open={!!confirmReceipt} onOpenChange={(o) => !o && !saving && onClose()}>
      <DialogContent className="max-w-sm" data-testid="dialog-confirmar-recebimento">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-violet-800">
            <PackageCheck className="w-6 h-6" />
            {confirmReceipt?.bulk ? "Confirmar todas em mãos?" : "Confirmar recebimento?"}
          </DialogTitle>
          <DialogDescription className="text-base pt-2">
            {confirmReceipt?.bulk
              ? (<><b>Você confirma que está com todos os {confirmReceipt.count} pedidos em mãos?</b><br/><span className="text-sm">Todos serão liberados como "Em Trânsito" imediatamente.</span></>)
              : (<><b>Você confirma que está com o pedido #{confirmReceipt?.entrega?.numero_pedido || "sem número"} em mãos?</b><br/><span className="text-sm text-muted-foreground">Cliente: {confirmReceipt?.entrega?.cliente_nome || "—"}</span></>)}
          </DialogDescription>
        </DialogHeader>
        {trocoList.length > 0 && (
          <TrocoSaidaCheck entregas={trocoList} checked={!!confirmReceipt.trocoOk} disabled={saving} onToggle={onToggleTroco} />
        )}
        <div className="flex gap-2 mt-4">
          <Button variant="outline" className="flex-1 h-11" onClick={onClose} disabled={saving} data-testid="btn-confirmar-receipt-cancelar">
            Ainda não
          </Button>
          <Button className="flex-1 h-11 bg-violet-700 hover:bg-violet-800 text-white font-bold" onClick={onConfirm}
            disabled={saving || precisaTroco} data-testid="btn-confirmar-receipt-ok">
            {saving ? "Confirmando..." : "Sim, estou com em mãos"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
